import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  Chart: {
    '&__chart': {
      backgroundColor: theme.palette.white,
      boxShadow: `0 0 5px ${theme.palette.white}`,
      borderRadius: 5,
    },
    '&__reset-zoom-container': {
      alignItems: 'center',
      backgroundColor: theme.palette.green,
      borderRadius: '50%',
      cursor: 'pointer',
      display: 'none',
      height: 25,
      justifyContent: 'center',
      position: 'absolute',
      left: 10,
      textAlign: 'center',
      bottom: 15,
      width: 25,
      zIndex: 10,
      '&__icon-reset-zoom': {
        color: theme.palette.black,
        height: 15,
        width: 15,
      },
    },
    '&--warning': {
      border: `3px solid ${theme.palette.primary.main}`,
      borderRadius: 5,
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      padding: 10,
    },
  },
  ChartCalc: {
    alignItems: 'center',
    display: 'flex',
    height: props => props.height,
    justifyContent: 'center',
    padding: '10px 5px',
    position: 'relative',
  },
}));

export { useStyles };
